import { GithubIcon } from './icons';

export const relatedLinks = [
  {
    icon: <GithubIcon />,
    title: 'Afluence',
    link: 'https://byafluence.com',
  },
];
